export default __webpack_public_path__ + "static/media/ArinzeNnamani.4fa888b3.svg";